import * as React from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { PRINTFULL_ID, FREEPRINTS_ID, INK_ID, DRAWPILLOWS_ID } from '../../constants';
import { formatDate } from '../../lib/formatDate';
import { useStyles } from './styles';

const CLIENT_COLUMNS: { id: string; label: string }[] = [
    { id: PRINTFULL_ID, label: 'Printful' },
    { id: FREEPRINTS_ID, label: 'Freeprints' },
    { id: INK_ID, label: 'INK' },
    { id: DRAWPILLOWS_ID, label: 'DrawPillows' },
];

interface OrdersCountTableProps {
    orders: any[];
}

/** Units per client per day; the Total column is the backend's figure and may include clients without a column. */
export default function OrdersCountTable({ orders }: OrdersCountTableProps) {
    const classes = useStyles();
    const quantityFor = (order: any, clientId: string) =>
        order?.clientData?.find((item: any) => String(item.clientId) === String(clientId))?.quantity || 0;

    return (
        <div className={classes.scroll}>
            <Table stickyHeader aria-label="Units by client">
                <TableHead>
                    <TableRow>
                        <TableCell>Date</TableCell>
                        {CLIENT_COLUMNS.map((client) => (
                            <TableCell key={client.id} align="right">{client.label}</TableCell>
                        ))}
                        <TableCell align="right">Total</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {orders.map((order, index) => (
                        <TableRow key={order?.date ?? index} hover>
                            <TableCell className={classes.date}>{formatDate(order?.date)}</TableCell>
                            {CLIENT_COLUMNS.map((client) => (
                                <TableCell key={client.id} className={classes.numeric}>{quantityFor(order, client.id)}</TableCell>
                            ))}
                            <TableCell className={`${classes.numeric} ${classes.total}`}>{order?.quantityByDate ?? '—'}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    );
}
